<template>
  <div id="records-details">
    <ipub-model :title="'Email Sending Details'"
                width="920px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <div class="table-detail">
        <ipub-table :columns="columns"
                    border
                    :pagination="false"
                    :dataSource="dataSource">
          <template v-slot:event="{ text }">
            <ipub-tooltip v-if="text">
              <div slot="title">
                <div v-if="text==='PROCESSED'">Message has been received and is ready to be delivered.</div>
                <div v-if="text==='DELIVERED'">Message has been successfully delivered to the receiving server.</div>
                <div v-if="text==='DROPPED'">In certain cases, SendGrid will “Drop” a message to a specific email address in order to protect your sender reputation.</div>
                <div v-if="text==='BOUNCE'">A bounce occurs when a sent message is rejected by the receiving mail server. The most common causes for bounced email messages include a misspelled or nonexistent email address.</div>
                <div v-if="text==='DEFERRED'">The incoming server cannot accept emails from your IP address for some reason.</div>
              </div>
              <div class="key-color"
                   v-if="['DROPPED','BOUNCE','DEFERRED'].includes(text)">{{emailEvent[text]}}</div>
              <div class=""
                   v-else>{{emailEvent[text]}}</div>
            </ipub-tooltip>
            <span v-else>--</span>
          </template>
          <template v-slot:time="{ text }">
            <div>{{text?$moment(text).format('HH:mm:ss DD / MM / YYYY'):'--' || '--'}}</div>
          </template>
          <template v-slot:actions="{ record }">
            <ipub-tooltip>
              <div slot="title">Edit</div>
              <ipub-icon type="iconEdit"
                         @click="edit(record)" />
            </ipub-tooltip>
          </template>
        </ipub-table>
      </div>
      <div class="content-detail mar-b-40 ipub-p2">
        <div class="mar-b-12">
          <span class="ipub-block__span">Subject</span>
          <div class="ipub-block__font">{{email.subject || '--'}}</div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">From</span>
          <div class="ipub-block__font">{{email.from&&email.from.email&&email.from.email.split(',').join(', ') || '--'}}</div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">To</span>
          <div class="ipub-block__font">{{email.toMail&&email.toMail.split(',').join(', ') || '--'}}</div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">CC</span>
          <div class="ipub-block__font">{{email.cc&&email.cc.split(',').join(', ') || '--'}}</div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">BCC</span>
          <div class="ipub-block__font">{{email.bcc&&email.bcc.split(',').join(', ') || '--'}}</div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">Attachment(s)</span>
          <div class="ipub-block__font">
            <div v-if="email.fileList && email.fileList.length">
              <div v-for="(item,index) in email.fileList"
                   @click="download(item)"
                   :key="item.id+index"
                   class="link-color ipub-cursor-pointer">{{item.name}}</div>
            </div>
            <span v-else>--</span>
          </div>

        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">Operation Time</span>
          <div class="ipub-block__font">{{email.operatorTime?$moment(email.operatorTime).format('HH:mm:ss DD / MMMM / YYYY'):'--' || '--'}}</div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">Operator</span>
          <div class="ipub-block__font">{{email.operator && email.operator.email || '--'}}</div>
        </div>
        <div class="mar-b-12">
          <span class="ipub-block__span">Letter Body</span>
          <div class="ipub-block__font">
            <div style="width: 100%;overflow-wrap: break-word;"
                 v-if="email.body"
                 v-html="email.body.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
            <span v-else>--</span>
          </div>
        </div>
      </div>
      <!-- <div>
        <ipub-button type="primary"
                     plain
                     style="width:120px;margin-left:16px"
                     @click="cancel">
          Cancel
        </ipub-button>
      </div> -->
    </ipub-model>
  </div>
</template>

<script>
import { mailReport } from '@/api/mail'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { mapGetters } from 'vuex'
import { EMAILEVENT } from '@/utils/dict'

const columns = [
  {
    title: '',
    enTitle: 'Email',
    width: 100,
    dataIndex: 'email',
    slot: 'omission'
  },
  {
    title: '',
    enTitle: 'Event',
    width: 100,
    dataIndex: 'event',
    slot: 'event'
  },
  {
    title: '',
    enTitle: 'Reason',
    width: 100,
    dataIndex: 'reason',
    slot: 'omission'
  },
  {
    title: '',
    enTitle: 'Time',
    width: 100,
    dataIndex: 'updateTime',
    slot: 'time'
  },

]
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      email: {},
      columns,
      dataSource: [{
        name: '1345', email: '45678'
      }],
      emailEvent: EMAILEVENT
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain'
    })
  },
  watch: {
    isVisable (val) {
      if (val) {
        this.getData()
      }
    }
  },
  methods: {
    async getData () {
      const data = await mailReport.query(this.id)
      this.email = data
      this.dataSource = this.email.details || []
      this.$emit('confirm')
    },

    cancel () {
      this.$emit('cancel')
    },
    download (item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
